var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2178 13.2852C27.9274 12.5939 28.1778 11.5793 27.8715 10.6378C27.5658 9.69592 26.7669 9.02233 25.7865 8.87987L19.7333 8.00033C19.426 7.95549 19.1605 7.76261 19.0232 7.48436L16.3161 1.99876C15.8778 1.11091 14.9902 0.559387 14 0.559387C13.0097 0.559387 12.1221 1.11091 11.6838 1.99876L8.97674 7.4843C8.83937 7.76266 8.57386 7.95554 8.26706 8.00028L2.21348 8.87982C1.23305 9.02233 0.434117 9.69592 0.128578 10.6373C-0.177836 11.5793 0.072578 12.594 0.781929 13.2851L5.16229 17.5553C5.38448 17.7718 5.48587 18.0837 5.43354 18.3892L4.39929 24.4187C4.23216 25.3949 4.62586 26.3628 5.42676 26.9445C6.22782 27.5266 7.27016 27.602 8.14713 27.1413L13.5613 24.2947C13.8359 24.1504 14.1639 24.1505 14.4383 24.2946L19.8529 27.1413C20.7299 27.602 21.7722 27.5266 22.5733 26.9445C23.3741 26.3627 23.7679 25.3949 23.6007 24.4187L22.5664 18.3895C22.5141 18.0837 22.6154 17.7718 22.8378 17.5551L27.2178 13.2852Z",
    fill: "#FFD600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled-star.ed3310d7a069c5e1e344fc605c34c829.svg";
export { ForwardRef as ReactComponent };